import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    EditFilled, UnlockFilled, LockFilled,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import viewIcon from '../../../src/img/view-icon.png';
import editIcon from '../../../src/img/edit-icon.png';
import plusIcon from '../../../src/img/plus.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import Parameters from 'shared/parameters';
import { AuthConsumer } from 'shared/contexts/AuthContext';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"


interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function CategoriesPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setLang] = useState('' as any);
    // const [searchInput, setSearchInput] = useState('');
    // const [filteredResults, setFilteredResults] = useState([] as any[]);
    // const searchItems = (searchValue:any) => {
    //     console.log(searchValue)
    //     setSearchInput(searchValue)
    //     if (searchValue !== '') {
    //         const filteredData = items.filter((item) => {
    //             return Object.values(item.name).join('').toLowerCase().includes(searchValue.toLowerCase())
    //         })
    //          console.log(filteredData)
    //          setFilteredResults(filteredData)
    //     }
    //     else{
    //          setFilteredResults(items)
    //     }
    // }
    const refreshItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchCategoriesAdmin({ order_by: 'id', page: 1, order: 'DESC' });
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#categoryList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                     
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                      
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem('language'));
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                    <div className={'list-page-wrapper'}>
                        <div className="container-fluid">
                            <div className={'d-flex justify-space-between mb-3'}>
                                <div className='p-0 d-flex align-items-center'>
                                    <div className={lang == 'ar' ? '' : 'mr-4'}>
                                    <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                    </div>
                                    <div className={lang == 'ar' ? 'ml-2' : ''}><h3 className='mb-0'>{t('genDict.categories')}</h3></div>
                                </div>
                                <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}>
                                    <Button className="btn btn-blue text-capitalize" onClick={() => history.push('categories/create')}>
                                        {/* <span className='d-flex align-items-center'><img src={plusIcon} className="mr-1"/>{t('genDict.add')+' category'}</span> */}
                                        <span className='d-flex align-items-center'><img src={plusIcon} className={lang == 'ar' ? 'ml-2' : 'mr-2'}/>{t('genDict.Category')}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 p-0'>
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="row mt-2">
                                            
                                            {/* <div className='col-lg-12 mb-2'>
                                                <h4 className='float-left'>{t('genDict.categories')}</h4>
                                                <div className='float-right d-flex align-items-center' style={{flexWrap:'nowrap'}}>
                                                    <span className='mr-2' style={{whiteSpace:'nowrap'}}>Search Category</span>  
                                                    <input type='text' name="" id="" onChange={(e) => searchItems(e.target.value)} placeholder='Enter Category Name' className='form-control'/>
                                                </div>
                                            </div> */}
                                        <div className="col-md-12 pb-3">
                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                <table id='categoryList' className="table  table-meetings table-report">
                                                <thead>
                                                    <tr>
                                                    <th className="text-uppercase text-secondary">{t('genDict.name')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.status')}</th>
                                                    <th className="text-uppercase text-secondary text-center">{t('genDict.SubCategory')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.createdAt')}</th>
                                                    <th className="text-uppercase text-secondary" style={{width:'100px'}}>{t('genDict.action')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                    //     searchInput.length > 1 ?
                                                    //     filteredResults && filteredResults.map(filtureddata => {
                                                    //         return <tr>
                                                    //         <td className="text-secondary">
                                                    //             <div className="d-flex align-items-center">
                                                    //                 <div className="mr-3">
                                                    //                     <img src={Parameters.ImageBaseUrl + filtureddata.image.slug + filtureddata.image.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                    //                 </div>
                                                    //                 <div className="">
                                                    //                     <p className="mb-0"><span>{filtureddata.name}</span></p>
                                                    //                 </div>
                                                    //             </div>
                                                    //         </td>
                                                    //         <td className="text-secondary">{filtureddata.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                    //         <td className="text-secondary text-center">
                                                    //             <button type='button' className='btn btn-sm btn-blue' onClick={() => {
                                                    //                 history.push(`/${filtureddata?.id}/sub-categories`)
                                                    //             }}>
                                                    //                 View/Add
                                                    //             </button>
                                                    //         </td>
                                                    //         <td className="text-secondary">{moment(filtureddata.created_at).format('DD MMMM, YYYY')}</td>
                                                    //         <td className="text-secondary">
                                                    //             <div className='d-flex align-items-center'>
                                                    //                 <div className='mr-3'>
                                                    //                 {
                                                    //                     filtureddata.status === 'INACTIVE' ? <Button  className="btn-danger" onClick={() => {
                                                    //                             API_SERVICE.activateCategory(filtureddata.id).then(() => {
                                                    //                                 refreshItems();
                                                    //                             }).catch((e) => {
                                                    //                                 notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    //                             });
                                                    //                         }
                                                    //                         } icon={<LockFilled/>}/> :
                                                    //                         <Button shape={'circle'} type={'primary'} onClick={() => {
                                                    //                             API_SERVICE.deactivateCategory(filtureddata.id).then(() => {
                                                    //                                 refreshItems();
                                                    //                             }).catch((e) => {
                                                    //                                 notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    //                             });
                                                    //                         }
                                                    //                         } className={'success-button '} icon={<UnlockFilled/>}/>
                                                    //                 }
                                                    //                 </div>
                                                    //                 <div className='mr-3'>
                                                    //                     <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                                    //                     onClick={() => {
                                                    //                         history.push(`/categories/${filtureddata.id}/view`);
                                                    //                     }}
                                                    //                     />
                                                    //                 </div>
                                                    //                 <div className='mr-3'>
                                                    //                     <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                                    //                     onClick={() => {
                                                    //                         history.push(`/categories/${filtureddata.id}/edit`);
                                                    //                     }}
                                                    //                     />
                                                    //                 </div>
                                                    //                 <div className='mr-3'>
                                                    //                 <Button type="primary" danger={false} shape="circle" icon={<DeleteOutlined/>}
                                                    //                 onClick={() => confirm({
                                                    //                     icon: <ExclamationCircleOutlined/>,
                                                    //                     title: t('genDict.confirmDelete'),
                                                    //                     okText: t('genDict.ok'),
                                                    //                     cancelText: t('genDict.cancel'),
                                                    //                     content: `${t('genDict.confirmDelete')} "${filtureddata.name}"`,
                                                    //                     okButtonProps: { loading: deletingItem, danger: true },
                                                    //                     onOk: async () => {
                                                    //                         setDeletingItem(true);
                                                    //                         API_SERVICE.removeCategories(filtureddata.id).then((d) => {
                                                    //                             if(d.data.status) {
                                                    //                                 notification.success({
                                                    //                                     message: t('genDict.success'),
                                                    //                                 });
                                                    //                                 refreshItems();
                                                    //                             } else {
                                                    //                                 notification.error({
                                                    //                                     message: d.data.message,
                                                    //                                 });
                                                    //                             }
                                                    //                             return;
                                                                                
                                                    //                         }).catch((e: any) => {
                                                    //                             notification.error({
                                                    //                                 message: t(API_SERVICE.handleErrors(e)),
                                                    //                             });
                                                    //                         }).finally(() => {
                                                    //                             setDeletingItem(false);
                                                    //                         });
                                                    //                     },
                                                    //                 })
                                                    //                 }/>
                                                    //                 </div>
                                                    //             </div>
                                                    //         </td>
                                                    //         </tr>
                                                    //     })
                                                    // :
                                                    items && items.map(item => {
                                                        console.log(item);
                                                        return <tr>
                                                        <td className="text-secondary">
                                                        <div className="d-flex align-items-center">
                                                            <div className="mr-3">
                                                                <img src={Parameters.ImageBaseUrl + item.image.slug + item.image.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                            </div>
                                                            <div className="">
                                                                <p className="mb-0"><span>{item.name}</span></p>
                                                            </div>
                                                        </div>
                                                        </td>
                                                        <td className="text-secondary">{item.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                        <td className="text-secondary text-center">
                                                                <button type='button' className='btn btn-sm btn-blue' onClick={() => {
                                                                    history.push(`/${item?.id}/sub-categories`)
                                                                }}>
                                                                    {t('genDict.ViewAdd')}
                                                                </button>
                                                            </td>
                                                        <td className="text-secondary">{moment(item.created_at).format('DD MMMM, YYYY')}</td>
                                                        <td className="text-secondary">
                                                            <div className='d-flex align-items-center'>
                                                                <div className='mr-3'>
                                                                    {
                                                                        item.status === 'INACTIVE' ? <Button  className='btn-danger' onClick={() => {
                                                                            API_SERVICE.activateCategory(item.id).then(() => {
                                                                                refreshItems();
                                                                            }).catch((e) => {
                                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                            });
                                                                        }
                                                                        } icon={<LockFilled/>}/> :
                                                                        <Button shape={'circle'} type={'primary'} onClick={() => {
                                                                            API_SERVICE.deactivateCategory(item.id).then(() => {
                                                                                refreshItems();
                                                                            }).catch((e) => {
                                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                            });
                                                                        }
                                                                        } className={'success-button '} icon={<UnlockFilled/>}/>
                                                                    }
                                                                </div>
                                                                <div className='mr-3'>
                                                                    <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                                                    onClick={() => {
                                                                        history.push(`/categories/${item.id}/view`);
                                                                    }}
                                                                    />
                                                                </div>
                                                                <div className='mr-3'>
                                                                    <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                                                    onClick={() => {
                                                                        history.push(`/categories/${item.id}/edit`);
                                                                    }}
                                                                    />
                                                                </div>
                                                                <div className='mr-3'>
                                                                <Button type="primary" danger={false} shape="circle" icon={<DeleteOutlined/>}
                                                                onClick={() => confirm({
                                                                    icon: <ExclamationCircleOutlined/>,
                                                                    title: t('genDict.confirmDelete'),
                                                                    okText: t('genDict.ok'),
                                                                    cancelText: t('genDict.cancel'),
                                                                    content: `${t('genDict.confirmDelete')} "${item.name}"`,
                                                                    okButtonProps: { loading: deletingItem, danger: true },
                                                                    onOk: async () => {
                                                                        setDeletingItem(true);
                                                                        API_SERVICE.removeCategories(item.id).then((d) => {
                                                                            if(d.data.status) {
                                                                                notification.success({
                                                                                    message: t('genDict.success'),
                                                                                });
                                                                                refreshItems();
                                                                            } else {
                                                                                notification.error({
                                                                                    message: d.data.message,
                                                                                });
                                                                            }
                                                                            return;
                                                                            
                                                                        }).catch((e: any) => {
                                                                            notification.error({
                                                                                message: t(API_SERVICE.handleErrors(e)),
                                                                            });
                                                                        }).finally(() => {
                                                                            setDeletingItem(false);
                                                                        });
                                                                    },
                                                                })
                                                                }/>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </AuthConsumer>
    );
}
